import {
  Button,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@ais-ui/ui-core';
import { ShipInfo } from '@ais-ui/websockets';

interface ShowShipPros {
  shipInfo: ShipInfo;
  setIsShowVesselActive: React.Dispatch<React.SetStateAction<boolean>>;
}

export function ShowShip({ shipInfo, setIsShowVesselActive }: ShowShipPros) {
  const onClick = () => {
    const url = shipInfo.imo
      ? `https://www.shipspotting.com/photos/gallery?imo=${shipInfo.imo}`
      : `https://www.shipspotting.com/photos/gallery?shipName=${shipInfo.name}`;

    const newWindow = window.open(url, '_blank');

    if (newWindow) {
      newWindow.opener = null;
    }
    setIsShowVesselActive(false);
  };

  return (
    <>
      <DialogHeader className="gap-y-2">
        <DialogTitle>You're accessing an external link</DialogTitle>
        <DialogDescription>
          You are about to navigate to www.shipspotting.com to get an image of
          the ship. Are you sure you want to proceed?
        </DialogDescription>
      </DialogHeader>
      <DialogFooter className="p-4">
        <Button id="show-ship-spotting-button" onClick={onClick}>
          Confirm
        </Button>
      </DialogFooter>
    </>
  );
}
